import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, WizardProgress } from '@grandvisionhq/common';

var ConfiguratorHeader = (_param)=>{
    var { className , currentStepIndex , disableSteps , skipSteps , stepNameLabels  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "currentStepIndex",
        "disableSteps",
        "skipSteps",
        "stepNameLabels"
    ]);
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": rest['data-t'],
        className: classnames('configurator-header', className)
    }, /*#__PURE__*/ React.createElement(WizardProgress, {
        steps: stepNameLabels,
        active: currentStepIndex,
        disableSteps: disableSteps,
        skipSteps: skipSteps,
        labelStyle: isPhone ? 'hidden' : 'inline'
    }));
};

export { ConfiguratorHeader };
//# sourceMappingURL=ConfiguratorHeader.js.map
